import React from 'react'
import { Link } from 'react-router-dom'
import { Alert, Card, Table } from 'react-bootstrap'
import AppBadge from 'shared/badges/app-badge'
import WeightBadge from 'shared/badges/weight-badge'
import { formatDateTime } from './format'

const COLUMNS = 5

// The latest error we know about for a municipality: an on-demand import
// error, or a failed custom-analytic run.
export const rowError = (row) =>
  row.import_error || (row.last_run_status === 'error' ? row.last_run_message || 'Run failed' : null)

const ErrorCell = ({ row }) => {
  const error = rowError(row)
  if (!error) return <span className="text-muted">—</span>
  return <span className="text-danger small">{error}</span>
}

const AnalyticMunicipalitiesTab = ({ analytic }) => {
  const rows = analytic.municipalities || []

  return (
    <Card>
      <Card.Body>
        <p className="text-muted small">
          Municipalities that have the {analytic.section_name || 'analytic’s'} module
          {analytic.custom ? ' (a custom analytic only runs for the municipality that owns it)' : ''}. Open flags
          are unresolved flags. Errors are from on-demand runs
          {analytic.custom ? ' and the latest custom-analytic run' : ''}; failures during the nightly Lambda run
          aren’t reported per analytic yet.
        </p>
        <div className="table-responsive">
          <Table bordered hover className="mb-0">
            <thead>
              <tr>
                <th>Municipality</th>
                <th className="text-end">Open Flags</th>
                <th>Weight</th>
                <th>Status</th>
                <th>Latest Error</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 && (
                <tr>
                  <td colSpan={COLUMNS} className="text-center text-muted py-4">
                    No municipality has this analytic’s module.
                  </td>
                </tr>
              )}
              {rows.map((row) => (
                <tr key={row.municipality_id} data-testid="municipality-row">
                  <td>
                    <Link to={`/admin/municipalities/${row.municipality_id}`}>{row.municipality_name}</Link>
                  </td>
                  <td className="text-end">{row.analytics_count.toLocaleString()}</td>
                  <td>{row.weight ? <WeightBadge weight={row.weight} /> : <span className="text-muted">Not set</span>}</td>
                  <td>
                    {row.status ? <AppBadge className="bg-light text-primary border">{row.status}</AppBadge> : '—'}
                    {row.last_run_at && (
                      <div className="small text-muted">Last run {formatDateTime(row.last_run_at)}</div>
                    )}
                  </td>
                  <td>
                    <ErrorCell row={row} />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        {rows.some(rowError) && (
          <Alert variant="warning" className="mt-3 mb-0 small">
            An error clears the next time the analytic runs successfully for that municipality.
          </Alert>
        )}
      </Card.Body>
    </Card>
  )
}

export default AnalyticMunicipalitiesTab
